<div class="modal-header modal-primary">
    <h5 class="modal-title">{{ titulo }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="frmPerfil" novalidate>
        <div class="form-group">
            <ng-template #nameHelp>{{ campos.name.help }}</ng-template>
            <label for="name">{{ campos.name.label }}:
                <span [hidden]="!campos.name.help" class="fa fa-question-circle text-info" role="button" [ngbTooltip]="nameHelp" placement="auto"></span>
            </label>
            <input type="text" class="form-control" id="name" formControlName="name" maxlength="100" [ngClass]="{ 'is-invalid' : frmPerfil.get('name').invalid }" />
        </div>
        <div class="form-row">
            <div class="form-group col-sm-6">
                <ng-template #usernameHelp>{{ campos.username.help }}</ng-template>
                <label class="form-label" for="username">{{ campos.username.label }}:
                    <span [hidden]="!campos.username.help" class="fa fa-question-circle text-info" role="button" [ngbTooltip]="usernameHelp" placement="auto"></span>
                </label>
                <input type="text" class="form-control" id="username" formControlName="username" maxlength="100" [ngClass]="{ 'is-invalid' : frmPerfil.get('username').invalid }" />
            </div>
            <div class="form-group col-sm-6">
                <ng-template #emailHelp>{{ campos.email.help }}</ng-template>
                <label class="form-label"for="email">{{ campos.email.label }}:
                    <span [hidden]="!campos.email.help" class="fa fa-question-circle text-info" role="button" [ngbTooltip]="emailHelp" placement="auto"></span>
                </label>
                <input type="email" class="form-control" id="email" formControlName="email" maxlength="50" [ngClass]="{ 'is-invalid' : frmPerfil.get('email').invalid }" />
            </div>
        </div>
        <fieldset><legend>Contraseña:</legend></fieldset>
        <div class="alert alert-info" role="alert">
            <strong>Recomendación:</strong> Para mayor seguridad usa una combinación de letras mayúsculas, minúsculas, números y caracteres especiales.
        </div>
        <div class="form-group">
            <ng-template #passwordHelp>{{ campos.password_actual.help }}</ng-template>
            <label class="form-label" for="password_actual">{{ campos.password_actual.label }}:
                <span [hidden]="!campos.password_actual.help" class="fa fa-question-circle text-info" role="button" [ngbTooltip]="passwordHelp" placement="auto"></span>
            </label>
            <div class="input-group">
                <input [type]="show1 ? 'text' : 'password'" class="form-control" id="password_actual" formControlName="password_actual" maxlength="20" [ngClass]="{ 'is-invalid' : frmPerfil.get('password_actual').invalid }" autocomplete="new-password" />
                <div class="show-hide" (click)="showPassword1()" *ngIf="!show1"><span class="show"><i class="icofont icofont-eye"></i></span></div>
                <div class="show-hide" (click)="showPassword1()" *ngIf="show1"><span class="Hide"><i class="icofont icofont-eye-blocked"></i></span></div>
            </div>
            <div *ngIf="frmPerfil.get('password_actual').errors && mensajes.msjError" class="text-danger">
                <div *ngIf="frmPerfil.get('password_actual').hasError('required')">Ingrese {{ campos.password_actual.label | lowercase }}.</div>
            </div>
            <div *ngIf="frmPerfil.get('password_actual').errors" class="text-danger">
                <div *ngIf="frmPerfil.get('password_actual').hasError('maxlength')">Máximo {{ frmPerfil.get('password_actual').errors.maxlength.requiredLength }} caracteres.</div>
            </div>
        </div>
        <div class="form-group">
            <ng-template #passwordHelp>{{ campos.password.help }}</ng-template>
            <label class="form-label" for="password">{{ campos.password.label }}:
                <span [hidden]="!campos.password.help" class="fa fa-question-circle text-info" role="button" [ngbTooltip]="passwordHelp" placement="auto"></span>
            </label>
            <div class="input-group">
                <input [type]="show2 ? 'text' : 'password'" class="form-control" id="password" formControlName="password" maxlength="20" [ngClass]="{ 'is-invalid' : frmPerfil.get('password').invalid }" autocomplete="new-password" />
                <div class="show-hide" (click)="showPassword2()" *ngIf="!show2"><span class="show"><i class="icofont icofont-eye"></i></span></div>
                <div class="show-hide" (click)="showPassword2()" *ngIf="show2"><span class="Hide"><i class="icofont icofont-eye-blocked"></i></span></div>
            </div>
            <div *ngIf="frmPerfil.get('password').errors && mensajes.msjError" class="text-danger">
                <div *ngIf="frmPerfil.get('password').hasError('required')">Ingrese {{ campos.password.label | lowercase }}.</div>
            </div>
            <div *ngIf="frmPerfil.get('password').errors" class="text-danger">
                <div *ngIf="frmPerfil.get('password').hasError('minlength')">Mínimo {{ frmPerfil.get('password').errors.minlength.requiredLength }} caracteres.</div>
                <div *ngIf="frmPerfil.get('password').hasError('maxlength')">Máximo {{ frmPerfil.get('password').errors.maxlength.requiredLength }} caracteres.</div>
            </div>
        </div>
        <div class="form-group">
            <ng-template #password_confirmHelp>{{ campos.password_confirmation.help }}</ng-template>
            <label class="form-label" for="password_confirmation">{{ campos.password_confirmation.label }}:
                <span [hidden]="!campos.password_confirmation.help" class="fa fa-question-circle text-info" role="button" [ngbTooltip]="password_confirmHelp" placement="auto"></span>
            </label>
            <div class="input-group">
                <input [type]="show3 ? 'text' : 'password'" class="form-control" id="password_confirmation" formControlName="password_confirmation" maxlength="20" [ngClass]="{ 'is-invalid' : frmPerfil.get('password_confirmation').invalid }" autocomplete="new-password" />
                <div class="show-hide" (click)="showPassword3()" *ngIf="!show3"><span class="show"><i class="icofont icofont-eye"></i></span></div>
                <div class="show-hide" (click)="showPassword3()" *ngIf="show3"><span class="Hide"><i class="icofont icofont-eye-blocked"></i></span></div>
            </div>
            <div *ngIf="frmPerfil.get('password_confirmation').errors && mensajes.msjError" class="text-danger">
                <div *ngIf="frmPerfil.get('password_confirmation').hasError('required')">Ingrese {{ campos.password_confirmation.label | lowercase }}.</div>
            </div>
            <div *ngIf="frmPerfil.get('password_confirmation').errors" class="text-danger">
                <div *ngIf="frmPerfil.get('password_confirmation')?.errors?.['notEqual']">Las contraseñas no coinciden.</div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button
        [class]="'btn '+ botones.guardar.tamanio.btn +' '+  botones.guardar.color.btn"
        [disabled] = "frmPerfil.invalid || loading"
        (click)="guardar()">
        <i [class]="botones.guardar.icono"></i> {{ botones.guardar.texto }}
    </button>
    <button
        [class]="'btn '+ botones.salir.tamanio.btn +' '+  botones.salir.color.btn"
        [disabled] = "loading"
        [ngbTooltip]="botones.salir.tooltip" placement="bottom"
        (click)="salir()">
        <i [class]="botones.salir.icono"></i> {{ botones.salir.texto }}
    </button>
</div>